import optmarket from "../../assets/images/slaider/optmarket.png";
import smcontrol from "../../assets/images/slaider/smcontrol.png";
import logistic from "../../assets/images/slaider/logistic.png";
import sklad from "../../assets/images/slaider/sklad.png";
import terminal from "../../assets/images/slaider/tehnovse.png";
import tehnocorp from "../../assets/images/slaider/tehnocorp.png";
import erp from "../../assets/images/slaider/erp.png";

export const stekData = [
  { id: 1, text: "Java" },
  { id: 2, text: "Kotlin" },
  { id: 3, text: "Swift" },
  { id: 4, text: "JavaScript" },
  { id: 5, text: "Python" },
  { id: 6, text: "C++" },
  { id: 7, text: "postgresql" },
  { id: 8, text: "docker" },
  { id: 9, text: "CI/CD" },
  { id: 10, text: "Gitlab" },
  { id: 11, text: "K8s" },
  { id: 12, text: "PHP" },
  { id: 13, text: "ESXi" },
  { id: 14, text: "Linux" },
  { id: 15, text: "ReactJS" },
  { id: 16, text: "Html/Css" },
];

export const tableEco = [
  {
    num: "62.0",
    description:
      "Разработка компьютерного программного обеспечения, консультационные услуги в данной области и другие сопутствующие услуги",
  },
  {
    num: "62.01",
    description: "Разработка компьютерного программного обеспечения",
  },
  {
    num: "62.02",
    description:
      "Деятельность консультативная и работы в области компьютерных технологий",
  },
  {
    num: "62.02.1",
    description:
      "Деятельность по планированию, проектированию компьютерных систем",
  },
  {
    num: "62.02.4",
    description:
      "Деятельность по подготовке компьютерных систем к эксплуатации",
  },
  {
    num: "62.02.9",
    description:
      "Деятельность консультативная в области компьютерных технологий прочая",
  },
  {
    num: "62.03",
    description: "Деятельность по управлению компьютерным оборудованием",
  },
  {
    num: "62.03.1",
    description: "Деятельность по управлению компьютерными системами",
  },
  {
    num: "62.03.11",
    description:
      "Деятельность по управлению компьютерными системами непосредственно",
  },
  {
    num: "62.09",
    description:
      "Деятельность, связанная с использованием вычислительной техники и информационных технологий, прочая Эта группировка включает: прочие информационные технологии, связанные с работой на компьютере, не включенные в другие группировки, в том числе: предоставление услуг по восстановлению компьютера после сбоя, установку (настройку) персональных компьютеров, установку программного обеспечения Эта группировка не включает: установку специализированных цифровых и аналоговых компьютеров; разработку компьютерного программного обеспечения; консультирование в области компьютерных систем; управление компьютерными техническими средствами; обработку данных и хостинг",
  },
  {
    num: "63.11.1",
    description:
      "Деятельность по созданию и использованию баз данных и информационных ресурсов",
  },
  {
    num: "63.12",
    description:
      "Деятельность web-порталов Эта группировка включает: функционирование web-сайтов с использованием поисковой системы для создания и поддержки обширной базы данных Интернет-адресов, содержащихся в легкодоступной форме; функционирование прочих web-сайтов, которые действуют как порталы информационно-коммуникационной сети Интернет (например, медиа-сайты, предлагающие периодически обновляемое содержание, СМИ, размещаемые в Интернете) Эта группировка не включает: издание книг, газет, журналов и т.д. через информационно-коммуникационную сеть Интернет; вещание через информационно-коммуникационную сеть Интернет",
  },
];

export const slides = [
  {
    id: 1,
    image: optmarket,
    title: "Opt Market",
    description: "Мобильное приложение для управления оптовой торговлей",
    hashtag: "Android",
    link: "/mobile",
  },
  {
    id: 2,
    image: smcontrol,
    title: "SMControl",
    description:
      "Мобильное приложение для контроля задач и управления бизнес-процессами",
    hashtag: "IOS",
    link: "/mobile",
  },
  {
    id: 3,
    image: logistic,
    title: "Моя Логистика",
    description: "Мобильное приложение для экспедиторов",
    hashtag: "Android",
    link: "/logistic",
  },
  {
    id: 4,
    image: sklad,
    // title: 'Моя Логистика',
    description: "Мобильное приложение для склада",
    hashtag: "Android",
    link: "/sklad",
  },
  {
    id: 5,
    image: terminal,
    title: "Partner Terminal",
    description:
      "Система электронной торговли для работы с розничными каналами продаж",
    hashtag: "Веб-система",
    link: "/web-development",
  },
  {
    id: 6,
    image: tehnocorp,
    title: "TechnoCorp",
    description: "Интернет-магазин",
    hashtag: "Веб-система",
    link: "/react",
  },
  {
    id: 7,
    image: erp,
    title: "ERP система премиум класса для оптовой торговли",
    // description: 'Мобильное приложение для экспедиторов',
    hashtag: "Веб-система",
    link: "/logistic",
  },
];
